import React from 'react';
import {useSearchParams} from 'react-router';
import {formatPublishedAt, toDate} from '../deltaDateUtils';
import {applyFintelSearchParamUpdates, FINTEL_SEARCH_PARAM_KEYS, getFintelSearchParam} from '../deltaSearchParams';

export default function useDeltaUrlState(reportDoc) {
    const [searchParams, setSearchParams] = useSearchParams();

    const defaultBaselineDate = React.useMemo(
        () => toDate(reportDoc?.updatedAt) || toDate(reportDoc?.createdAt),
        [reportDoc?.updatedAt, reportDoc?.createdAt]
    );

    const [baselineDate, setBaselineDate] = React.useState(() => {
        const baselineFromUrl = toDate(getFintelSearchParam(searchParams, 'BASELINE'));
        return baselineFromUrl || defaultBaselineDate;
    });

    const updateDeltaSearchParams = React.useCallback((updates) => {
        setSearchParams(
            (prev) => applyFintelSearchParamUpdates(prev, updates),
            {replace: true}
        );
    }, [setSearchParams]);

    React.useEffect(() => {
        const baselineFromUrl = toDate(getFintelSearchParam(searchParams, 'BASELINE'));
        setBaselineDate(baselineFromUrl || defaultBaselineDate);
    }, [defaultBaselineDate, searchParams]);

    React.useEffect(() => {
        updateDeltaSearchParams({
            [FINTEL_SEARCH_PARAM_KEYS.BASELINE]: formatPublishedAt(baselineDate),
        });
    }, [baselineDate, updateDeltaSearchParams]);

    return {
        searchParams,
        baselineDate,
        setBaselineDate,
        updateDeltaSearchParams,
    };
}

